import type React from 'react';
import Linker from 'app/shared/modules/Linker';
import appleBadge from 'images/apple-badge.svg';
import androidBadge from 'images/android-badge.svg';

type Device = 'ios' | 'android';

type MobileAppLinkProps = {
  adgroup: string;
  device: Device;
  onClick?: () => void;
  alt?: string;
  children?: React.ReactNode;
};

const DEFAULT_ALT: Record<Device, string> = {
  ios: 'Image of the Apple App Store badge',
  android: 'Image of the Google Play Store badge',
};

const MobileAppLink = ({ adgroup, device, onClick, alt, children }: MobileAppLinkProps) => {
  const href = `/mobile-apps/${device}?adgroup=${encodeURIComponent(adgroup)}`;
  const badge = device === 'ios' ? appleBadge : androidBadge;

  return (
    // escape so the browser navigates to the Express redirect instead of react-router intercepting.
    <Linker to={href} onClick={onClick} escape target="_blank" rel="nofollow">
      {children ?? <img src={badge} alt={alt || DEFAULT_ALT[device]} width="120px" height="35px" />}
    </Linker>
  );
};

export default MobileAppLink;
